import * as React from 'react';

import { ButtonType, ButtonWidget, InteractionState } from '@tableau/widgets';

import { CommonStyles } from '../../common/react/CommonStyles';
import { imgPath } from '../../common/utilities/ImgUrl';
import { ReactDirectiveProps } from '../../ts/directives/reactDirectiveFactory';
import { HeaderSearchBox } from '../header/HeaderSearchBox';
import { PageHeaderButtonType, PageHeaderIconPaths, PageHeaderIcons } from './PageHeader';
import { PageHeaderStyles } from './PageHeaderStyles';

export interface SearchProps extends ReactDirectiveProps {
  searchClosed: (event: BaseJQueryEventObject) => void;
}

export function PageHeaderSearch(props: SearchProps): JSX.Element {
  return (
    <div className={'tb-page-header-search'}>
      <HeaderSearchBox
        angularContext={props.angularContext}
        omniboxOpenWidth={350}
        searchClosed={props.searchClosed}
        isSearchOpen={true}
      />
    </div>
  );
}

const glassIcons: PageHeaderIcons = {
  lightIcons: {
    active: imgPath('spaces_toolbar_search_active_white.svg'),
    inactive: imgPath('spaces_toolbar_search_white.svg')
  },
  regularIcons: {
    active: imgPath('spaces_toolbar_search_active.svg'),
    inactive: imgPath('spaces_toolbar_search.svg')
  }
};

const closeIcons: PageHeaderIcons = {
  lightIcons: {
    active: imgPath('spaces_toolbar_delete_active_white.svg'),
    inactive: imgPath('spaces_toolbar_delete_white.svg')
  },
  regularIcons: {  // this should never need non-white icons
    active: imgPath('spaces_toolbar_delete_active_white.svg'),
    inactive: imgPath('spaces_toolbar_delete_white.svg')
  }
};

interface IconInfo {
  src: string;
  width: number;
  height: number;
}

function buttonIconInfo(isSearchOpen: boolean, showActiveIcon: boolean, buttonType: PageHeaderButtonType): IconInfo {
  if (isSearchOpen) {
    const icons: PageHeaderIconPaths = closeIcons.lightIcons;
    return {
      width: 32,
      height: 32,
      src: showActiveIcon ? icons.active : icons.inactive
    };

  } else { // search is not open
    const icons: PageHeaderIconPaths = (buttonType === 'light') ? glassIcons.lightIcons : glassIcons.regularIcons;
    return {
      width: 32,
      height: 32,
      src: showActiveIcon ? icons.active : icons.inactive
    };
  }
}

const getButtonContent = (isSearchOpen: boolean, buttonType: PageHeaderButtonType): (state: InteractionState) => JSX.Element => {
  return (state: InteractionState): JSX.Element => {
    const showActiveIcon = state.hover || state.active || state.focus;
    const iconInfo = buttonIconInfo(isSearchOpen, showActiveIcon, buttonType);
    return (
      <div style={{...CommonStyles.Layout.FlexBlockLeftAndCenter, height: PageHeaderStyles.height}}>
        <img
          style={{width: iconInfo.width, height: iconInfo.height}}
          src={iconInfo.src}
        />
      </div>
    );
  };
};

export interface VizViewerSearchButtonProps {
  readonly isSearchOpen: boolean;
  readonly title: string;
  readonly testId: string;
  readonly onClick: () => void;
}

export function VizViewerSearchButton(props: VizViewerSearchButtonProps): JSX.Element {
  return (
    <ButtonWidget
      buttonType={ButtonType.IconOutline}
      getContent={getButtonContent(props.isSearchOpen, 'light')}
      title={props.title}
      testId={props.testId}
      handleClick={props.onClick}
    />
  );
}
